import React, { useMemo } from 'react';
import SearchableCombobox from '../SearchableCombobox';

const CustomFieldSelect = ({ fieldName, customFields, selectedValue: receivedSelectedValue, handleChange }) => {
  let selectedValue = receivedSelectedValue || '';
  if (selectedValue && customFields && !customFields.includes(selectedValue)) {
    selectedValue = '';
  }

  const options = useMemo(() => customFields.map((field) => ({ value: field, label: field })), [customFields]);

  return (
    <SearchableCombobox
      options={options}
      value={selectedValue || null}
      onChange={(value) => handleChange({ target: { name: fieldName, value } })}
      placeholder="Please select a field"
      clearable
    />
  );
};

export default React.memo(CustomFieldSelect);
